import React from "react";
import * as s from "./index.module.scss";
import { PrismicRichText } from "@prismicio/react";

function TermsAndConditionsBlog({ title, description }) {
  return (
    <section className={s.terms_container}>
      <div className={s.body_container}>
        <h1 className={`heading ${s.title}`}>{title}</h1>
        <div className="sub-title">
          <PrismicRichText field={description || []} />
        </div>
      </div>
    </section>
  );
}

export default TermsAndConditionsBlog;
